import type { ConversationNodeTags } from 'lib-shared-types-api';

type RoutedThroughTagsProps = {
  node: ConversationNodeTags;
};

export function RoutedThroughTags({
  node,
}: RoutedThroughTagsProps): JSX.Element {
  return (
    <>
      Tags · Tagged with <strong>{node.tag_ids.join(', ')}</strong>
    </>
  );
}
